import styled from 'styled-components';

import Link from 'components/link';

export const TotalsContainer = styled.div`
  background-color: ${Styles.color.grey.five};
  margin-bottom: 1.5rem;
  // account for 1rem margin on totals row
  padding: 0.25rem 1.875rem 1.25rem;
`;

export const WarningContainer = styled.div`
  padding-bottom: 0.5rem;
`;

export const TermsContainer = styled.div`
  margin-top: 2rem;
`;

export const TermsLink = styled(Link)`
  text-decoration: underline;
`;
